import { FC, PropsWithChildren, useMemo } from 'react';
import { MenuActionControlProviderContext, MenuActionControlProviderContextType } from '#baseMenu/contexts';
import { MenuActionControl } from '#baseMenu/objects';

const MenuActionControlProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const menuActionControl = useMemo<MenuActionControl>(() => new MenuActionControl(), []);

  const menuActionControlContextValue: MenuActionControlProviderContextType = {
    menuActionControl,
  };

  return (
    <MenuActionControlProviderContext value={menuActionControlContextValue}>
      {children}
    </MenuActionControlProviderContext>
  );
};

export { MenuActionControlProvider };
